import { Component, OnInit } from '@angular/core';
import { } from "@angular/forms";
import { VproService } from 'src/app/service/vpro/vpro.service';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from "ngx-spinner";
import { OrgService } from 'src/app/models/orgsrv';

@Component({
  selector: 'app-orgsrv',
  templateUrl: './orgsrv.component.html',
  styleUrls: ['./orgsrv.component.css']
})
export class OrgsrvComponent implements OnInit {

  orgsrvs = new OrgService;
  submitted = false;
  isActive: true;
  srvdet = [];
  data: any;
  org_code: any;
  orgSrvForm: any;
  constructor(
    private orgsrv: VproService, private spinner: NgxSpinnerService
  ) { }



  ngOnInit() {
    this.getCheckinId();
    this.orgsrvs.org_code = localStorage.getItem("orgcode");
    console.log("OCODE=>", this.orgsrvs.org_code)
  }

  async addOrgSrv() {
    this.submitted = true;
    this.save();
    this.getCheckinId();
  }

  private save(): void {
    let data: any;
    console.log(this.orgsrvs);
    this.orgsrv.addOrgSrv(this.orgsrvs).subscribe();
    // SweetAlert
    Swal.fire({
      position: "top",
      type: "success",
      title: "Medical service has been added",
      showConfirmButton: false,
      timer: 1700,
    });
    this.getCheckinId();
    this.orgsrvs.service_quantity = '';
    this.orgsrvs.service_cost = '';
    this.orgsrvs.service_description = '';
    this.orgsrvs.service_name = '';
    this.orgsrvs.service_type = '';
  }

  updateOrgService(orgserv) {
    console.log(orgserv);
    let updatedOrgService: any = {};
    Object.assign(updatedOrgService, orgserv);

    this.orgSrvForm.patchValue(updatedOrgService);
  }

  submitService(values) {
    console.log(values);

    if (values.org_code && !isNaN(values.org_code)) {
      this.orgsrv
        .updateOrgService(this.org_code, values)
        .subscribe((result) => {

          this.orgSrvForm.reset();
        });
    } else {
      values.org_code = this.org_code;

      this.orgsrv.addPrescription(values).subscribe((result) => {
        this.orgSrvForm.reset();
      });
    }
  }

  // Remove service by org_code
  removeConfirm(org_code: number) {
    this.spinner.show();
    this.orgsrv.deleteOrgService(org_code).subscribe(
      (data) => {
        this.spinner.hide();
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 2500,
        });

        Toast.fire({
          type: "success",
          title: "Medical service has been deleted successfuly",
        });
        console.log('Record deleted', data);
        this.getCheckinId();
      })

  }

  getCheckinId() {
    this.orgsrv.getOrgService(localStorage.getItem("orgcode")).subscribe(data => {
      this.srvdet = data;
      console.log(this.data);
    });

  }
}